import React, { Suspense } from 'react';
import { Route } from 'react-router-dom'
import PreLoader from '../components/elements/PreLoader';
import AuthHeader from '../components/header/AuthHeader';

/* Popup Layout */
const AuthLayout = ({ children, ...rest }) => {
  const bodyBg = rest.pageBgData && rest.pageBgData
    .filter((data) => data.backgroundType === BackgroundTypeEnum.Body)
    .filter((element) => {
      const elementPages = element.pages.filter((el) => el.prefix + el.alias === rest.alias || el.prefix + el.alias + '-lobby' === rest.alias);
      return element.forAllPages ? true : elementPages && elementPages.length ? true : false;
    });

  // Function to get main block style
  const getMainStyle = () => {
    const background = bodyBg && bodyBg[0];
    // const position = bodyBgPosition && bodyBgPosition[0];
    const topBannerHeight = document.querySelector('.top-banner-section')?.clientHeight;
    if (background) {
      const bgImg = background.imageUrl
        ? background.imageUrl
        : `/img/backgrounds/${background.id}${background.extension}?v=${background.lastModifiedDate}`;
      return {
        minHeight: topBannerHeight,
        backgroundImage: `url("${bgImg}")`,
      };
    }
    return { minHeight: topBannerHeight };
  };
  return (
    <div
      className={`wrapper`}>
      {/* <Suspense fallback={<></>}>
        {!Utils.isTablet() && <SideBarMenu />}
      </Suspense> */}
      <AuthHeader />
      <main
        className={`main-block ${bodyBg && bodyBg.length ? StylesHelper.getBgSize(bodyBg) : ''} 
                  ${bodyBg && bodyBg.length && bodyBg[0].backgroundPosition === BackgroundPositionEnum.Fixed ? 'main-img_fixed' : ''} `}
        style={getMainStyle()}>
        {getContent({ children, ...rest })}
      </main>
    </div>
  )
}

/* Popup Layout */
const getContent = ({ children, ...rest }) => {
  return rest.isSettingsLoading ? <PreLoader spinning={rest.isSettingsLoading}>
    <div style={{ height: '100%', width: '100%' }}></div>
  </PreLoader> : children
}

/*
  Private route wrapper
 */

export const AuthRoute = ({ component: Component, isSettingsLoading, ...rest }) => {
  return (
    <Route {...rest} render={matchProps => {
      return (
        rest.language ? <AuthLayout key={rest.language} isSettingsLoading={isSettingsLoading}>
          <Suspense fallback={<PreLoader spinning={rest.isSettingsLoading}>
            <div style={{ height: '100%', width: '100%' }}></div>
          </PreLoader>}>
            <Component {...matchProps} />
          </Suspense>
        </AuthLayout> : null
      )
    }} />
  )
};

